import { CountryCodes } from '@axiom/const';

export const CountryUtil = {
  isNoAdHocCountry(addressCountry: string | null): boolean {
    return [CountryCodes.DE, CountryCodes.CH].includes(addressCountry);
  },
};
